<template lang="pug">
  .contents-container
    el-row(:gutter='20')
      el-col(:span='12' v-for='(i, index) in list' :key='index')
        el-card(class='c-boxcard')
          .clearfix(slot='header')
            span {{i.title}}
          .item
            dl
              dt 公開
              dd {{data[i.key].public}}件
            dl
              dt 非公開
              dd {{data[i.key].private}}件
    el-row(:gutter='20')
      el-col(:span='24')
        el-button(type='primary' size='mini' @click="onCopyPageList") ページリストをコピー
        el-button(type='primary' size='mini')
          a(href="https://developers.facebook.com/tools/debug/sharing/batch/" target="_blank") Batch Invalidator
</template>

<script>
import * as api from '@/api/dashboard'
import * as apiStories from '@/api/stories'
import * as apiWorks from '@/api/works'
import * as apiTalent from '@/api/talent'
export default {
  name: 'PagesDashboard',
  data () {
    return {
      list: [
        {
          key: 'portfolio',
          title: 'Works'
        },
        {
          key: 'talent',
          title: 'Talents'
        },
        {
          key: 'news',
          title: 'Press'
        },
        {
          key: 'newsletter',
          title: 'wow magazine'
        },
        {
          key: 'casestudy',
          title: 'Case Study'
        }
      ],
      data: {
        casestudy: {
          private: 0,
          public: 0,
          total: 0
        },
        news: {
          private: 0,
          public: 0,
          total: 0
        },
        newsletter: {
          private: 0,
          public: 0,
          total: 0
        },
        portfolio: {
          private: 0,
          public: 0,
          total: 0
        },
        talent: {
          private: 0,
          public: 0,
          total: 0
        }
      },
      tableData: [
        {
          status: '公開',
          num: 10
        },
        {
          status: '非公開',
          num: 10
        }
      ]
    }
  },
  methods: {
    init () {
      this.getData()
    },
    getData () {
      api.get()
        .then((res) => {
          this.data = res.data
        })
        .catch((res) => {
        })
    },
    formatter (row, column) {
      return row.num + '件'
    },
    onCopyPageList () {
      const copytest = []
      Promise.all([apiTalent.get(), apiWorks.get(), apiStories.get()]).then((values) => {
        values[0].data.data.forEach((v) => {
          if (v.key && v.status === 1) {
            copytest.push('https://' + location.hostname + '/talent/' + v.key)
          }
        })
        values[2].data.data.forEach((v) => {
          if (v.key && v.status === 1) {
            copytest.push('https://' + location.hostname + '/works/' + v.key)
          }
        })
        values[3].data.data.forEach((v) => {
          if (v.key && v.status === 1) {
            copytest.push('https://' + location.hostname + '/stories/' + v.key)
          }
        })
        navigator.clipboard.writeText(copytest.join(' ')).then(function () {
          /* clipboard successfully set */
          alert('コピー成功')
        }, function () {
          /* clipboard write failed */
        })
      })
    }
  },
  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Dashboard/index.vue